window.addEventListener('load',()=>document.body.classList.add('loaded'));
document.addEventListener('DOMContentLoaded',()=>{
 const glow=document.createElement('div');glow.className='cursor-glow';document.body.appendChild(glow);document.addEventListener('mousemove',e=>{glow.style.left=e.clientX+'px';glow.style.top=e.clientY+'px'});
 document.querySelectorAll('.premium-card,.product-card,.collection-card').forEach(card=>{card.addEventListener('mousemove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.transform=`translateY(-12px) rotateX(${-y*8}deg) rotateY(${x*8}deg)`});card.addEventListener('mouseleave',()=>card.style.transform='')});
 const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)e.target.classList.add('in')}),{threshold:.12});document.querySelectorAll('.section,.product-card,.premium-card').forEach(el=>io.observe(el));
});

// Working mobile menu + product search
(function(){
  const btn=document.querySelector('[data-menu-toggle]'); const menu=document.querySelector('[data-mobile-menu]');
  if(btn&&menu){btn.addEventListener('click',()=>menu.classList.toggle('open'));}
  document.querySelectorAll('[data-product-search]').forEach(input=>{
    input.addEventListener('input',()=>{
      const q=input.value.toLowerCase().trim();
      const root=input.closest('.section')||document;
      root.querySelectorAll('[data-title]').forEach(card=>{
        const hay=(card.getAttribute('data-title')+' '+(card.getAttribute('data-category')||'')).toLowerCase();
        card.classList.toggle('hidden', q && !hay.includes(q));
      });
    });
  });
})();

// Product variant image + full gallery switching
(function(){
  document.querySelectorAll('[data-product-section]').forEach(function(section){
    var main = section.querySelector('[data-main-product-image]');
    var select = section.querySelector('[data-variant-select]');
    var price = section.querySelector('[data-product-price]');
    var thumbs = section.querySelectorAll('.thumb-btn');
    function setActiveBySrc(src){ thumbs.forEach(function(t){ t.classList.toggle('active', t.getAttribute('data-thumb-src') === src); }); }
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        var src = btn.getAttribute('data-thumb-src');
        if(main && src){ main.src = src; setActiveBySrc(src); }
      });
    });
    if(select){
      select.addEventListener('change', function(){
        var opt = select.options[select.selectedIndex];
        if(price && opt.dataset.price) price.textContent = opt.dataset.price;
        if(main && opt.dataset.image){ main.src = opt.dataset.image; setActiveBySrc(opt.dataset.image); }
      });
    }
  });
})();


// Reliable product accordion open/close
(function(){
  function wireAccordions(root){
    (root || document).querySelectorAll('.product-accordion details, .accordion details').forEach(function(detail){
      var summary = detail.querySelector('summary');
      if(!summary || summary.dataset.ncAccordionReady) return;
      summary.dataset.ncAccordionReady = 'true';
      summary.setAttribute('role','button');
      summary.setAttribute('tabindex','0');
      function toggle(e){
        e.preventDefault();
        e.stopPropagation();
        detail.open = !detail.open;
      }
      summary.addEventListener('click', toggle, true);
      summary.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ toggle(e); }
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ wireAccordions(document); });
  else wireAccordions(document);
  document.addEventListener('shopify:section:load', function(e){ wireAccordions(e.target); });
})();

// HARD FIX: custom product accordions that do not rely on <details>
(function(){
  function syncItem(item, open){
    var btn=item.querySelector('.nc-accordion-trigger');
    var panel=item.querySelector('.nc-accordion-panel');
    var icon=btn && btn.querySelector('span');
    item.classList.toggle('is-open', open);
    if(btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if(panel) panel.hidden = !open;
    if(icon) icon.textContent = open ? '−' : '+';
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('.nc-accordion-trigger');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var item=btn.closest('.nc-accordion-item');
    if(!item) return;
    syncItem(item, !item.classList.contains('is-open'));
  }, true);
  function init(){
    document.querySelectorAll('.nc-accordion-item').forEach(function(item){
      syncItem(item, item.classList.contains('is-open'));
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
